<template>
  <section>
    <dep-header v-on:changed="tabChanged" title="Home"> </dep-header>
    <div class="page-content">
      <div class="container planner-list"></div>
    </div>
  </section>
</template>

<script>
import DepHeader from "@/components/global/layout/DepHeader";
import HeaderSection from "./HeaderSection.vue";
import SingleTableLayout from "../webon/webon-table/SingleTableLayout.vue";
import SideFiltersLayout from "@/components/global/webon/webon-table/SideFiltersLayout.vue";

export default {
  data: function () {
    return {
      tabs: [],
      currentWindow: "",
    };
  },
  components: {
    DepHeader,
    HeaderSection,
    SingleTableLayout,
    SideFiltersLayout,
  },
  methods: {
    tabChanged: function (tab) {
      this.currentWindow = tab.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.planner-list {
  padding: 0 50px;
}
</style>
